export default {
  placeholder: 'Bedrijf zoeken...',
};
